
import showHeaderFooter from '@util/headerFooterUtils'
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue'
import { TripLog } from '@/generated-clients/myTrips';
import { Location } from 'vue-router';

@Component({
  name: 'RestartSetupSection'
})
export default class RestartSetupSection extends Vue {
  @Prop({ required: true })
  private triplog: TripLog;

  @Prop({ default: false })
  private hasNoTrips: boolean;

  @Prop({ default: false })
  private teaserWidget: boolean;

  get vehicleString() {
    const { brand, model, licensePlate } = this.triplog.vehicle;
    return licensePlate ? `${brand} ${model} (${licensePlate})` : `${brand} ${model}`;
  }

  get setupLocation(): Location {
    return { name: 'vehicleSetup', params: { id: this.triplog.vehicle.id.toString() }, query: { step: '0', from: 'myTrips' } };
  }

  addHeaderFooter() {
    if (!this.teaserWidget) {
      return;
    }

    showHeaderFooter();
  }
}
